export const getMenuItems = () => {
  // Items do menu ação
  return [
    { key: "1", label: "Ativar Anúncio" },
    { key: "2", label: "Desativar Anúncio" },
    { key: "3", label: "Exibir Anúncio" },
  ];
};
